module.exports = __webpack_public_path__ + "img/img2.9390ce03.jpg";